import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import PricingExamples from '../components/PricingExamples';
import HowItWorks from '../components/HowItWorks';
import Features from '../components/Features';
import FAQ from '../components/FAQ';
import CtaSection from '../components/CtaSection';
import Footer from '../components/Footer';

const LandingPage = () => {
  return (
    <div className="inn-home">
      <Navbar />
      <main>
        <Hero />
        <PricingExamples />
        <HowItWorks />
        <Features />
        <FAQ />
        <CtaSection />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;
